import ListingDetailsPreview from './ListingDetailsPreview.page';

export default ListingDetailsPreview;